module.exports = __webpack_public_path__ + "static/media/1-8.16e477d6.mp3";